var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgModelFourExample(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 342,
    height: 201,
    viewBox: "0 0 342 201",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12804",
    "data-name": "Group 12804",
    transform: "translate(-8855 -1648)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8650",
    "data-name": "Rectangle 8650",
    width: 47,
    height: 46,
    rx: 23,
    transform: "translate(9138 1648)",
    fill: "#f4f7fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9866",
    "data-name": "Path 9866",
    d: "M-11.5-7.187a6.47,6.47,0,0,0,6.469-6.469A6.47,6.47,0,0,0-11.5-20.125a6.47,6.47,0,0,0-6.469,6.469A6.47,6.47,0,0,0-11.5-7.187ZM-5.75-5.75H-8.225a7.828,7.828,0,0,1-3.275.719,7.844,7.844,0,0,1-3.275-.719H-17.25A5.75,5.75,0,0,0-23,0V.719a2.157,2.157,0,0,0,2.156,2.156H-2.156A2.157,2.157,0,0,0,0,.719V0A5.75,5.75,0,0,0-5.75-5.75Z",
    transform: "translate(9173 1680.125)",
    fill: "#d5dee8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9846",
    "data-name": "Path 9846",
    d: "M1942.059-254v74",
    transform: "translate(7077.941 1956)",
    fill: "#d5dee8",
    stroke: "#d5dee8",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8704",
    "data-name": "Rectangle 8704",
    width: 16,
    height: 16,
    rx: 8,
    transform: "translate(9048 1756)",
    fill: "#d5dee8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8702",
    "data-name": "Rectangle 8702",
    width: 16,
    height: 16,
    rx: 8,
    transform: "translate(9104 1756)",
    fill: "#d5dee8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8703",
    "data-name": "Rectangle 8703",
    width: 16,
    height: 16,
    rx: 8,
    transform: "translate(9076 1756)",
    fill: "#d5dee8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8699",
    "data-name": "Rectangle 8699",
    width: 16,
    height: 16,
    rx: 8,
    transform: "translate(9132 1756)",
    fill: "#d5dee8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8700",
    "data-name": "Rectangle 8700",
    width: 16,
    height: 16,
    rx: 8,
    transform: "translate(9160 1756)",
    fill: "#d5dee8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8694",
    "data-name": "Rectangle 8694",
    width: 54,
    height: 6,
    rx: 3,
    transform: "translate(8872 1711)",
    fill: "#d5dee8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8695",
    "data-name": "Rectangle 8695",
    width: 87,
    height: 6,
    rx: 3,
    transform: "translate(8872 1725)",
    fill: "#d5dee8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8696",
    "data-name": "Rectangle 8696",
    width: 54,
    height: 5,
    rx: 2.5,
    transform: "translate(8872 1739)",
    fill: "#d5dee8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8688",
    "data-name": "Rectangle 8688",
    width: 136,
    height: 6,
    rx: 3,
    transform: "translate(8872 1752)",
    fill: "#d5dee8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8697",
    "data-name": "Rectangle 8697",
    width: 47,
    height: 6,
    rx: 3,
    transform: "translate(8872 1762)",
    fill: "#d5dee8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9397",
    "data-name": "Path 9397",
    d: "M4.109,68.614H4.094a2.45,2.45,0,0,1-1.322-.649C2.714,67.92.4,66.222,0,65.912v3.471a.769.769,0,0,0,.769.769H7.433a.769.769,0,0,0,.769-.769V65.912c-.392.307-2.714,2.008-2.771,2.053A2.449,2.449,0,0,1,4.109,68.614ZM7.433,64H.769A.769.769,0,0,0,0,64.769v.3a.386.386,0,0,0,.147.3c.49.383.652.519,2.778,2.062.269.2.8.67,1.176.663s.907-.468,1.176-.663C7.4,65.9,7.565,65.761,8.055,65.376a.383.383,0,0,0,.147-.3v-.3A.769.769,0,0,0,7.433,64Z",
    transform: "translate(8855 1660.888)",
    fill: "#d5dee8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9847",
    "data-name": "Path 9847",
    d: "M4.243-1.515,2.274-2.359a.42.42,0,0,0-.165-.034.421.421,0,0,0-.327.155L.91-1.172A6.51,6.51,0,0,1-2.2-4.287l1.065-.872a.42.42,0,0,0,.156-.327.42.42,0,0,0-.034-.166L-1.862-7.62a.425.425,0,0,0-.389-.255.421.421,0,0,0-.094.011l-1.828.422a.422.422,0,0,0-.327.411h0A8.155,8.155,0,0,0,3.656,1.125h0A.422.422,0,0,0,4.068.8L4.489-1.03a.428.428,0,0,0,.01-.094A.426.426,0,0,0,4.243-1.515Z",
    transform: "translate(8859.5 1717)",
    fill: "#d5dee8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9848",
    "data-name": "Path 9848",
    d: "M1.556-5.062C1.3-6.632.7-7.734,0-7.734s-1.3,1.1-1.556,2.672ZM-1.688-3.375A11.02,11.02,0,0,0-1.63-2.25H1.628a11.015,11.015,0,0,0,.058-1.125A11.015,11.015,0,0,0,1.628-4.5H-1.63A11.02,11.02,0,0,0-1.688-3.375ZM4.02-5.062A4.369,4.369,0,0,0,1.243-7.552a5.933,5.933,0,0,1,.879,2.489ZM-1.245-7.552A4.366,4.366,0,0,0-4.02-5.062h1.9A5.909,5.909,0,0,1-1.245-7.552ZM4.208-4.5H2.192c.037.369.058.747.058,1.125s-.021.756-.058,1.125H4.206a4.322,4.322,0,0,0,.151-1.125A4.4,4.4,0,0,0,4.208-4.5ZM-2.25-3.375c0-.378.021-.756.058-1.125H-4.208a4.4,4.4,0,0,0-.151,1.125A4.4,4.4,0,0,0-4.208-2.25h2.014C-2.229-2.619-2.25-3-2.25-3.375Zm.694,1.687C-1.3-.118-.7.984,0,.984s1.3-1.1,1.556-2.672ZM1.245.8A4.373,4.373,0,0,0,4.022-1.687h-1.9A5.933,5.933,0,0,1,1.245.8ZM-4.02-1.687A4.369,4.369,0,0,0-1.243.8a5.933,5.933,0,0,1-.879-2.489Z",
    transform: "translate(8859.359 1745)",
    fill: "#d5dee8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9849",
    "data-name": "Path 9849",
    d: "M-.347.943a.422.422,0,0,0,.694,0C2.9-2.759,3.375-3.139,3.375-4.5A3.375,3.375,0,0,0,0-7.875,3.375,3.375,0,0,0-3.375-4.5C-3.375-3.139-2.9-2.759-.347.943ZM0-3.094A1.406,1.406,0,0,1-1.406-4.5,1.406,1.406,0,0,1,0-5.906,1.406,1.406,0,0,1,1.406-4.5,1.406,1.406,0,0,1,0-3.094Z",
    transform: "translate(8859.375 1758)",
    fill: "#d5dee8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8690",
    "data-name": "Rectangle 8690",
    width: 54,
    height: 6,
    rx: 3,
    transform: "translate(8942 1711)",
    fill: "#d5dee8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9850",
    "data-name": "Path 9850",
    d: "M1942.059-254v6",
    transform: "translate(6991.941 1965)",
    fill: "#d5dee8",
    stroke: "#d5dee8",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8691",
    "data-name": "Rectangle 8691",
    width: 65,
    height: 9,
    rx: 4.5,
    transform: "translate(8855 1659)",
    fill: "#d5dee8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8692",
    "data-name": "Rectangle 8692",
    width: 66,
    height: 9,
    rx: 4.5,
    transform: "translate(8924 1659)",
    fill: "#d5dee8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8693",
    "data-name": "Rectangle 8693",
    width: 97,
    height: 6,
    rx: 3,
    transform: "translate(8855 1676)",
    fill: "#d5dee8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8698",
    "data-name": "Rectangle 8698",
    width: 69,
    height: 6,
    rx: 3,
    transform: "translate(8968 1676)",
    fill: "#d5dee8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9851",
    "data-name": "Path 9851",
    d: "M1942.059-254v7",
    transform: "translate(7017.941 1929)",
    fill: "#d5dee8",
    stroke: "#d5dee8",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8724",
    "data-name": "Rectangle 8724",
    width: 342,
    height: 61,
    rx: 5,
    transform: "translate(8855 1788)",
    fill: "#f4f7fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9870",
    "data-name": "Path 9870",
    d: "M20004.525-9040.347v7.856h-26.986v-3.487l5.344-5.344,4.625,4.625,10.131-10.132Z",
    transform: "translate(-10964.001 10861)",
    fill: "#d5dee8",
    stroke: "#d5dee8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_836",
    "data-name": "Ellipse 836",
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    transform: "translate(9012 1809)",
    fill: "#d5dee8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8728",
    "data-name": "Rectangle 8728",
    width: 165,
    height: 38,
    rx: 5,
    transform: "translate(9032 1710)",
    fill: "#f4f7fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9870-2",
    "data-name": "Path 9870",
    d: "M20004.525-9040.347v7.856h-26.986v-3.487l5.344-5.344,4.625,4.625,10.131-10.132Z",
    transform: "translate(-10876.001 10771)",
    fill: "#d5dee8",
    stroke: "#d5dee8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_836-2",
    "data-name": "Ellipse 836",
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    transform: "translate(9100 1719)",
    fill: "#d5dee8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModelFourExample);
export default __webpack_public_path__ + "static/media/ModelFourExample.70e6a8c3e0818f5ac947570e560a3c9c.svg";
export { ForwardRef as ReactComponent };